'use strict';

import {
    createElements,
    userPrevent,
} from '../../functions';
import { isMobile, projectMode, settingsData } from '../../settings';
import {CardTypes, ViewMode} from "../../common";
import gsap from 'gsap';
import {openSearchHandler} from "../search/search";
import { getCurrentLangDirection, isDesktopMode} from '../language/langSwitcher';
import {
    closePages,
    getActiveMenuData,
    setMenuActive,
} from '../menu/menu';
import { closePanorama, isPanoramaActive, panoramaCloseHandler } from '../widgets/poi/poiv3';
import { checkMapPanoramaInOrbit } from '../poi/poi';
import {UnitCardClass} from "../cards/unitCards/UnitCardClass";
import {closeOptionsCard} from "../cards/cardsFunctions";
import { showHideButtonPlay } from '../camera-auto-tour/cameraTour';

export const rightNavigationBar = () => {
    const buttonsArr = [
        {
            name: 'district',
            tagType: 'button',
            classes: ['button-modes', 'button-modes--district', 'icon-district'],
            dataAttr: 'district',
            isVisible: false
        },
        {
            name: 'orbit',
            tagType: 'button',
            classes: ['button-modes', 'button-modes--orbit', 'icon-orbit-project'],
            dataAttr: 'orbit',
            // isVisible: buildings_info.length > 1
            isVisible: false
        },
        {
            name: 'orbit',
            tagType: 'button',
            classes: ['button-modes', 'button-modes--orbit', 'icon-orbit-building'],
            dataAttr: 'orbit',
            // isVisible: buildings_info.length === 1
            isVisible: false
        },
        {
            name: 'cylinder',
            tagType: 'button',
            classes: ['button-modes', 'button-modes--cylinder', 'icon-cylinder-building'],
            dataAttr: 'cylinder',
            isVisible: false
        },
        {
            name: 'floorplan',
            tagType: 'button',
            classes: ['button-modes', 'button-modes--splitFloor', 'icon-floorplan', 'hide'],
            dataAttr: 'floorplan',
            isVisible: false
        },
        {
            name: 'play',
            tagType: 'button',
            classes: ['button-modes', 'button-modes--play', 'icon-play'],
            dataAttr: 'play',
            isVisible: false
        },
        {
            name: 'back',
            tagType: 'button',
            classes: ['button-modes', 'button-modes--back','icon-back'],
            dataAttr: 'back',
            isVisible: true
        },
        // {
        //     name: 'filter',
        //     tagType: 'button',
        //     unitCards: ['button-filter', 'icon-search', 'non-canvas'],
        //     dataAttr: 'filter',
        //     isVisible: true
        // },
    ];

    const container = createElements('div', ['right-nav-bar', 'non-canvas', 'hide'], document.body);
    const wrapper = createElements('div', ['right-nav-bar__wrapper', 'non-canvas'], container);
    const buttonsWrapper = createElements('div', ['buttons__wrapper', 'non-canvas'], wrapper);
    const headerCheckBox = document.querySelector('.header__burger-menu__input');

    headerCheckBox && headerCheckBox.addEventListener('change', () => {
        rightNavMenuZIndexChange(2);
    },false);

    for (const {name, tagType, classes, isVisible, dataAttr} of buttonsArr) {
        let element;

        if (isVisible) {
            switch (name) {
                case settingsData.activeViewMode: {
                    classes.push('active');
                    break;
                }
                case 'play': {
                    element = createElements(tagType, classes, wrapper, 'afterbegin');
                    break;
                }
                case 'back': {
                    element = createElements(tagType, classes, buttonsWrapper, 'afterbegin');

                    if (isDesktopMode()){
                        element.classList.add('prevent-hide');
                    }

                    if (isMobile){
                        element.classList.remove('icon-back');
                        element.classList.add('icon-right');
                    }

                    break;
                }
                // case 'filter': {
                //     element = createElements(tagType, unitCards, wrapper);
                //     break;
                // }
                default: {
                    element = createElements(tagType, classes, buttonsWrapper);
                    break;
                }
            }
            element.setAttribute('data-button', dataAttr);
        }
    }

    buttonsWrapper.addEventListener('click', buttonsWrapperHandler);
}

export function buttonsWrapperHandler ({target}) {
    // if (!isOrbitControlsEnabled()){
    //     return;
    // }
    // if (settingsData.bombBlock) return;

    if (userPrevent()) return;


    const changeModeTo = target.getAttribute('data-button');

    if (!changeModeTo || changeModeTo === settingsData.activeViewMode && changeModeTo !== ViewMode.FloorPlan) {
        return;
    }

    if (settingsData.activeViewMode === 'cylinder')
        projectMode.Pagination.paginate({source: 'searchBackNavButton'});
    viewModesSwitching(changeModeTo);
}

export async function viewModesSwitching(changeModeTo) {
    // const container = document.querySelector('.right-nav-bar');

    // if (!settingsData.bombBlock) {
        // changeLightEnvironment(changeModeTo);
    // }
    // if (config.features?.projectTour?.active && !config.features?.blockCylinderMode) {
    //     changeModeTo !== ViewMode.Orbit
    //         ? showHideButtonPlay('hide')
    //         : showHideButtonPlay('show');
    // }

    switch (changeModeTo) {
        case ViewMode.District: {
            districtModeHandler();
            return;
        }
        case ViewMode.Orbit: {

            if (settingsData.activeViewMode === ViewMode.FloorPlan){
               await projectMode.FloorPlan.exitFromMode();
               await projectMode.Cylinder.exitFromMode();
            } else if (settingsData.activeViewMode === ViewMode.Cylinder){
                await projectMode.Cylinder.exitFromMode();
            }


            // return ;
            //
            // removeSearchContainer().then(()=>{

                // showHideButtonPlay('show');
                //
                // if (settingsData.buildingDestroyed) {
                //     cylinderModeHandler('fromDestroy');
                // } else {
                //     changeLightEnvironment(changeModeTo);
                // }

                // const orbitPromise = new Promise(resolve => {
                //     resolve(true);
                // })
                //     .then(() => isMobile ? UnitCardClass.closeMobileCard() : UnitCardClass.closeMultipleCards())
                //     .then(() => setTimeout(() => orbitModeHandler(), 500));
                //
                // settingsData.animationsList.push(orbitPromise);
                //
                // changeActiveRightMenuBtns(changeModeTo);
                //
                // container && !container.classList.contains('hide') && container.classList.add('hide');
            //
            // });
            //
            // hideRightNavBar();

            break;
        }
        case ViewMode.Cylinder: {
            await projectMode.FloorPlan.exitFromMode();
            // if (config.features?.blockCylinderMode) return;
            // showHideButtonPlay('hide');
            // // removeHeaderSubstrateInCylinder();
            // cylinderModeHandler();
            // changeActiveRightMenuBtns(changeModeTo);
            //
            // // container && container.classList.contains('hide') && container.classList.remove('hide');
            break;
        }
        case ViewMode.FloorPlan: {
            console.log('floor plan')
            // if (settingsData.buildingDestroyed) changeModeTo = ViewMode.Cylinder;
            // // showHideButtonPlay('hide');
            // floorPlanModeHandler();
            // changeActiveRightMenuBtns(changeModeTo);
            //
            // container && container.classList.contains('hide') && container.classList.remove('hide');
            break;
        }
        case 'back' : {
            // showHideButtonPlay('show');
            if (settingsData.bombBlock) return;
            backButtonHandlerThrottling();
            break;
        }
        default: break;
    }
    if (settingsData.activeViewMode === ViewMode.Orbit)
        projectMode.Pagination.paginate({source: 'viewModesSwitching', note: 'orbit'} );
}

let timer;
function backButtonHandlerThrottling() {
    if (timer !== null) {
        clearTimeout(timer);
    }

    timer = setTimeout(function() {
        backButtonHandler();
    }, 250);
}

function districtModeHandler() {
    console.log('district is not developed');
    moveElements();
}
// async function orbitModeHandler() {
//     removeSelectionBoxesLockColor();
//     manualHide360Icons();
//
//     const timePlug = new Promise(resolve => setTimeout(()=> resolve(true),1000));
//     settingsData.animationsList.push(timePlug);
//
//     await fitModelInViewport();
//     removeCylinderFloorNumbers();
//     settingsData.customSelections = [];
//
//     settingsData.objects_to_intersection = [];
//     settingsData.instanced_floors = [];
//     settingsData.floor_obj = [];
//     // hideCylindersGrid();
//
//     // environmentToggle();
//     // backgroundShow();
//     // poiToggle(true);
//     additionalMenuToggle();
//     // toggleStreetNames(true);
//     // setTimeout(resizeCanvasWhenMenuOpened,500);
//     // resizeCanvasWhenMenuOpened();
//
//     // showAllBuildings();
//     showPointsModels('Trees small');
//     showPointsModels('Trees big');
//     setMenuActive('3dModel');
//
//     if (typeof settingsData.orbitAnimationCout === 'number'){
//         settingsData.orbitAnimationCout = 0;
//     }
//
//     if (document.body.classList.contains('filter-open')) {
//         document.querySelector('.filter-module-open-btn').click();
//     }
//
//     const buildingSwitcher = document.getElementById('building-switcher');
//
//     buildings_info.forEach(tower => {
//         // if (tower.isActive) {
//         //     changeShadowsOptions(tower, true);
//         // }
//
//         tower.searchResult = [];
//         tower.isActive = false;
//     });
//
//     // if (buildingSwitcher) buildingSwitcher.classList.add('hide');
//     if (buildingSwitcher) hideBuildingSwitcher();
//     // hideRightNavBar();
//
//     const popup = document.querySelector('.popup-info');
//     if (popup && !popup.classList.contains('hide')){
//         popup.classList.add('hide');
//     }
//
//     // setTimeout(() => {
//         // buildingsLabelsToggle();
//         // buildingsLabelUpdate();
//         // resizeCanvasWhenMenuOpened();
//
//         // hideCylindersGrid();
//         // showAllBuildings();
//         await setDefaultForeshortening();
//         // environmentToggle();
//         // toggleStreetNames(true);
//         // backgroundShow();
//         // poiToggle(true);
//
//
//         setTimeout(()=>{
//             mobileBurgerStyleToggle();
//             showAllBuildings();
//             environmentToggle();
//             hideCylindersGrid();
//             toggleStreetNames(true);
//             backgroundShow();
//             poiToggle(true);
//             // setDefaultForeshortening();
//         //     resizeCanvasWhenMenuOpened();
//         //     setDefaultForeshortening();
//         //     // hideCylindersGrid();
//         //     // showAllBuildings();
//         //     // environmentToggle();
//         //     // toggleStreetNames(true);
//         //     // backgroundShow();
//         //     // poiToggle(true);
//         },500)
//         // resizeCanvasWhenMenuOpened();
//     // }, 1000);
//
//     moveElements();
// }
// export function cylinderModeHandler(fromDestroy, buildingIndex) {
//     console.log('cylinderModeHandler');
//     return;
//     const buildingSwitcher = document.getElementById('building-switcher');
//
//     if (buildingSwitcher && buildingSwitcher.classList.contains('hide') && buildings_info.length > 1) {
//         // buildingSwitcher.classList.remove('hide');
//         // showBuildingSwitcher();
//     } else {
//         BuildingSwitch.add(document.querySelector('.main-wrap'));
//     }
//
//     if (isMobile){
//         closePoiInfoWindowCardInOrbit(true);
//     } else {
//         closePoiInfoWindowCardInOrbit(false);
//     }
//
//     // let activeTower = buildings_info.find(tower => tower.isActive);
//     let activeTower;
//
//     if (buildingIndex){
//         activeTower = buildings_info[buildingIndex];
//     } else {
//         activeTower = buildings_info.find(tower => tower.isActive);
//     }
//
//
//     if (!activeTower) {
//         buildings_info[0].isActive = true;
//         activeTower = buildings_info[0];
//     }
//
//     if (settingsData.buildingDestroyed) {
//         bombButtonInitActionHandler();
//         // setTimeout(searchResizeCanvas, 1000);
//         setTimeout(canvasResize(), 1000);
//     } else {
//         BuildingSwitch.change_building_to(buildings_info.indexOf(activeTower));
//         turnOffAllEnvironment();
//     }
//
//     if (!fromDestroy) {
//         // setTimeout(() => {
//             const searchContainer = document.querySelector('.search__container-main');
//             !searchContainer && openSearchHandler(1.5);
//         // }, 1500);
//     }
//
//
//     setMenuActive('search');
//     moveElements();
//     changeGridTexture();
// }
// function floorPlanModeHandler() {
//     if (!settingsData.lastClickedFlat) {
//         const activeTower = buildings_info.find(tower => tower.isActive);
//         const maxFloor = Math.max(...activeTower.crm_data.map(item => item.floorNum));
//         settingsData.lastClickedFlat = activeTower.all_apartments.find(apartment => apartment.userData.crm_data.floorNum === parseInt(maxFloor / 2));
//         settingsData.currentFloor = settingsData.lastClickedFlat.userData.floor;
//     }
//
//     bombButtonInitActionHandler();
//     moveElements();
// }
function backButtonHandler() {

    const exitFromWidget = backWidgetButton();
    if (exitFromWidget){
        if (settingsData.activeViewMode === ViewMode.Orbit){
            hideRightNavBar();
        }
        return;
    }

    const card = document.querySelector(`.${CardTypes.Options}-card`);
    if (card) {
        closeOptionsCard();
        return;
    }

    // removeSelectionBoxesLockColor();
    const unitCard = UnitCardClass.findCard()?.html;
    unitCard && UnitCardClass.closeMultipleCards();
    switch (settingsData.activeViewMode) {
        case ViewMode.Orbit: break;
        case ViewMode.Cylinder: viewModesSwitching(ViewMode.Orbit) ; break;
        case ViewMode.FloorPlan: viewModesSwitching(ViewMode.Cylinder); break;
        default: break;
    }
}

export function backWidgetButton () {
    if (isDesktopMode()){
        const valueArray = ['gallery','about','map'];
        const activeMenuData = getActiveMenuData();

        if (checkMapPanoramaInOrbit()){
            panoramaCloseHandler(document.querySelector('.map__panorama__orbit__show'));
            hideRightNavBar();
            return;
        }

        if (valueArray.includes(activeMenuData)){

            if(isPanoramaActive()){
                closePanorama();
                return false;
            }

           closePages();

            if (settingsData.activeViewMode === ViewMode.Orbit){
                setMenuActive('3dModel');
                showHideButtonPlay('show');
            } else {
                setMenuActive('search');
            }
           settingsData.stopRender = false;
           if (settingsData.activeViewMode === ViewMode.Cylinder) {
               const isSearchOpened = document.querySelector('.search__container-main');
               !isSearchOpened && openSearchHandler();
            }
           return true;
        }
        return false;
    }
    return false;
}

// export function changeActiveRightMenuBtns(changeModeTo) {
//     settingsData.activeViewMode = changeModeTo;
//     const buttons = document.querySelectorAll('.button-modes');
//
//     buttons.forEach(button => {
//         const dataBtn = button.getAttribute('data-button');
//         button.classList.remove('active');
//
//         if (dataBtn === changeModeTo) {
//             button.classList.add('active');
//         }
//
//         switch (dataBtn) {
//             case ViewMode.FloorPlan: {
//                 if (changeModeTo === ViewMode.Orbit) {
//                     button.classList.add('hide');
//                     break;
//                 }
//
//                 button.classList.remove('hide');
//                 break;
//             }
//             case ViewMode.Orbit: {
//                 if (changeModeTo === ViewMode.Orbit) {
//                     button.classList.remove('icon-right');
//                     button.classList.add('icon-orbit-project');
//                     break;
//                 }
//
//                 button.classList.remove('icon-orbit-project');
//                 button.classList.add('icon-right');
//             }
//         }
//     });
// }

export function moveElements() {
    const buildingSwitch = document.getElementById('building-switcher');
    const leftNavBar = document.querySelector('.left-nav-bar');
    const searchBtn = document.querySelector('.filter-module-open-btn');
    const root = document.querySelector(':root');

    if (!buildingSwitch) return;

    if (buildingSwitch.classList.contains('hide')) {
        leftNavBar && leftNavBar.classList.contains('move') && leftNavBar.classList.remove('move');
        searchBtn && searchBtn.classList.contains('move') && searchBtn.classList.remove('move');
    } else {
        leftNavBar && !leftNavBar.classList.contains('move') && leftNavBar.classList.add('move');
        root.style.setProperty('--left-bar-bottom-move', "calc(34px + 24px + 42px)")
        searchBtn && !searchBtn.classList.contains('move') && searchBtn.classList.add('move');
    }
}

export function rightNavMenuZIndexChange(zIndex) {
    const rightNavBar = document.querySelector('.right-nav-bar');

    setTimeout(() => {
        if (isMobile && settingsData.isLandscape) {
            const unitCard = UnitCardClass.findCard()?.html;
            const floorSlider = document.querySelector('.fs-container');

            if (!zIndex) {
                if (!unitCard || unitCard && floorSlider || !unitCard && floorSlider) {
                    zIndex = 4;
                } else if (unitCard && !floorSlider) {
                    zIndex = 2;
                }
            }

            if (+rightNavBar.style.zIndex === zIndex) return;

            rightNavBar.style.zIndex = `${zIndex || 2}`;
        } else if (isMobile && document.querySelector(`.search__container-bottom.opened`)) {
            if (+rightNavBar.style.zIndex === 4) {
                rightNavBar.style.zIndex = 2;
            }
        }
    }, 250);
}

export function showRightNavBar () {
    let navbar = document.querySelector('.right-nav-bar');
    const langDirection = getCurrentLangDirection();
    let styleProp = langDirection === 'ltr' ? 'right' : 'left';

    if (isDesktopMode()){
        styleProp = 'right';
        const backBtn = document.querySelector('.menu__back-btn');
        // backBtn.style.opacity = 0;

        gsap.fromTo(navbar, {[styleProp]: -200, autoAlpha:0},{
            [styleProp]: 32,
            autoAlpha: 1,
            duration: .2,
            onStart:()=>{
                navbar.classList.remove('hide');
                navbar.classList.add('showed');
            },
            onComplete:()=>{
                navbar.style.removeProperty('left');
                navbar.style.removeProperty('right');
            }});


        gsap.fromTo(backBtn, {[styleProp]: -500, autoAlpha:0},{[styleProp]: -80, autoAlpha: 1, duration: .45,
            onStart:()=>{
                backBtn.classList.remove('prevent-hide');
            },
            onComplete:()=>{
                backBtn.style.removeProperty('opacity');
            }});

        return;
    }

    if (navbar.classList.contains('showed')){
        return;
    }

    gsap.fromTo(navbar, {[styleProp]: -200, autoAlpha:0 },{[styleProp]: 32, autoAlpha: 1, duration: 1,
        onStart:()=>{
            navbar.style.removeProperty('left');
            navbar.style.removeProperty('right');
            navbar.classList.remove('hide');
        },
        onComplete:()=>{
            navbar.style.removeProperty('left');
            navbar.style.removeProperty('right');
            navbar.classList.add('showed');
        }});
}

export function toggleBackBtnInDesktopMode (action) {
    if (!isDesktopMode()){
        return;
    }

    const rightNavBar = document.querySelector('.right-nav-bar');

    switch (action) {
        case 'hide':
            hideRightNavBar();
            break;
        case 'show':
            rightNavBar.classList.contains('hide') && showRightNavBar();
            break;

    }
}

export function hideRightNavBar () {
    let navbar = document.querySelector('.right-nav-bar');
    const langDirection = getCurrentLangDirection();
    let styleProp = langDirection === 'ltr' ? 'right' : 'left';

    if (isDesktopMode()){
        styleProp = 'right';
        const backBtn = document.querySelector('.menu__back-btn');

        gsap.to(backBtn,{[styleProp]: -500, opacity: 0, duration: .45,
            onStart:()=>{

            },
            onComplete:()=>{
                backBtn.classList.add('prevent-hide');
            }});

        gsap.to(navbar,{[styleProp]: -200, opacity: 0, duration: .2,
            onStart:()=>{
                navbar.classList.remove('showed');
            },
            onComplete:()=>{
                navbar.classList.add('hide');
            }});


    } else {

        gsap.to(navbar,{[styleProp]: -200, opacity: 0, duration: 1,
            onStart:()=>{
                navbar.style.removeProperty('left');
                navbar.style.removeProperty('right');
                navbar.classList.remove('showed');
            },
            onComplete:()=>{
                navbar.classList.add('hide');
            }});
    }
}